import React, { useState, useEffect } from 'react';
import { SalesSupplierForm } from './SalesSupplierForm';
import {
  useGetAllDaysSelect,
  useSelectSuppliers,
} from '../hooks/SalesSupplierHook';
import { useObtenerDiasPorEvento } from '../../../reportes/cortesias/hooks/CortesiasHook';
import { styleSelect, themeSelect } from '../../../../../rbts/assets/ts/_utils';
import Select from 'react-select';
import { SalesSupplierGrid } from './SalesSupplierGrid';
import { SimpleAlert } from '../../../../../rbts/helpers';
import { MensajeDia } from '../../../../../rbts/helpers/components/MensajeDia';

type Props = {
  id?: number;
};

const ViewAE: React.FC<Props> = () => {
  const [reloadTipo] = useState<number>(Math.random() * 40);
  const { suppliers, loadingRequest } = useSelectSuppliers(true, reloadTipo, true);
  const { catalog: day } = useGetAllDaysSelect();
  const { list: listadosDeDias, loadingRequest: cargandoDias } = useObtenerDiasPorEvento(0);

  const [supplierSelected, setSupplierSelected] = useState<any>(null);
  const [diaSeleccionado, setDiaSeleccionado] = useState<any>(null);
  const [showSaleForm, setShowSaleForm] = useState<boolean>(false);
  const [strDate, setStrDate] = useState<string>('');
  const [currentDay, setCurrentDay] = useState<number>(0);
  const [filter, setFilter] = useState<any>({ id_dia: null, id_punto_venta: null });

  useEffect(() => {
    if (day) {
      const { dia: { id }, fecha_str } = day;
      setStrDate(fecha_str);
      setCurrentDay(id);
    }
  }, [day]);


  // Actualiza el filtro cuando cambia día o punto de venta
  useEffect(() => {
    setFilter({
      id_dia: diaSeleccionado ? diaSeleccionado.value : null,
      id_punto_venta: supplierSelected ? supplierSelected.value : null,
    });
  }, [diaSeleccionado, supplierSelected]);

  const closeSecction = () => {
    setShowSaleForm(false);
  };

  return (
    <>
      {currentDay === 0 ? (
        <MensajeDia mensaje={''} />
      ) : (
        <>
          <div className="d-flex flex-column flex-xl-row">
            <div className="col-xl-12">
              <div className="card mb-5">
                <div className="card-header border-0">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-gray-800">
                      Búsqueda por punto de venta
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                      <div className="w-100 pe-5">
                        <div className="w-100 d-flex">
                          <label className="required form-label w-auto">
                            Nombre:{' '}
                          </label>
                        </div>
                        <Select
                          options={suppliers}
                          value={supplierSelected}
                          styles={styleSelect}
                          theme={themeSelect}
                          classNamePrefix="tc-select"
                          placeholder={'Seleccione'}
                          isSearchable={true}
                          noOptionsMessage={() => (
                            <span>{'No se encontraron registros'}</span>
                          )}
                          onChange={(option: any) =>
                            setSupplierSelected(option ?? null)
                          }
                          isLoading={loadingRequest}
                          isClearable
                          backspaceRemovesValue
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                      <div className="w-100 pe-5">
                        <button
                          type="button"
                          title="Nueva venta"
                          onClick={() => {
                            if (supplierSelected) {
                              setShowSaleForm(!showSaleForm);
                            } else {
                              SimpleAlert(
                                'Seleccione un punto de venta.',
                                3000,
                                'error'
                              );
                            }
                          }}
                          className={`btn w-200px mt-8 ${
                            !showSaleForm ? 'btn-primary' : 'btn-light'
                          }`}
                        >
                          <span className="indicator-label">
                            {!showSaleForm ? 'Nueva venta' : 'Cancelar'}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {!showSaleForm ? (
                <div className="card mb-5">
                  <div className="card-header border-0">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Ventas realizadas
                      </span>
                    </h3>
                    <div className="card-toolbar">
                      <div style={{ minWidth: '280px' }}>
                        <label className="fw-bold fs-7 mb-1 d-block text-white">
                          Día Administrativo
                        </label>
                        <Select
                          value={diaSeleccionado}
                          isLoading={cargandoDias}
                          options={listadosDeDias}
                          styles={styleSelect}
                          theme={themeSelect}
                          classNamePrefix="tc-select"
                          placeholder="Seleccione un día"
                          onChange={(option: any) =>
                            setDiaSeleccionado(option ?? null)
                          }
                          isClearable
                          noOptionsMessage={() => 'Sin opciones'}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <SalesSupplierGrid filter={filter} />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {showSaleForm ? (
                <div className="card">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Nueva venta
                        {supplierSelected?.label
                          ? ` - ${supplierSelected.label}`
                          : ''}
                      </span>
                    </h3>
                    <h3 className="card-title">
                      <span className="card-label fw-bold text-gray-800">
                        Fecha administrativa:
                      </span>
                      <span className="fs-4 text-gray-700">{strDate}</span>
                    </h3>
                  </div>
                  <SalesSupplierForm
                    supplierId={supplierSelected?.value}
                    dayId={currentDay}
                    handleClose={closeSecction}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export { ViewAE };
